<template>
  <el-scrollbar class="ml-3">
    <div v-for="(message, x) in messages" :key="x">
      <div class="flex">
        <div class="task-avatar">
          <img class="avatar" :src="getAvatar(message)" />
        </div>
        <div class="h-20px ml-[12px]">
          <div class="flex flex-col">
            <div class="task-avatar-name">
              <span>{{ `${message.User.FirstName ?? ''} ${message.User.LastName ?? ''}` }}</span>
            </div>
            <div class="mt-[4px] justify-start task-avatar-time">
              <!-- <span>12:23 04 APR 2022 </span> -->
              <span>{{ dayjs(message.TimesheetEventDateTime).format('DD/MM/YYYY HH:mm') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="flex mt-[8px] text-sm font-medium mb-[30px]">
        <p>
          {{ message.Message }}
        </p>
      </div>
    </div>
  </el-scrollbar>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import IconSvg from "@/layouts/IconBase.vue";
import dayjs from "dayjs";
import { imageEndpoint } from "config/enviroments";
export default defineComponent({
  name: "IconCalendar",
  props: {
    messages: {
      type: Array,
      required: true,
    },
  },
  components: {
    IconSvg,
  },
  setup(props, ctx) {
    const messages = ref<MessageEventModel[]>(props.messages! as any);
    const updateMessage = (listMessage: MessageEventModel[]) => {
        messages.value = listMessage
    }
    const getAvatar = (item: any) => {
      if(item?.User?.AvatarUrl) {
        return `${imageEndpoint}/${item.User.AvatarUrl}?t=${ Date.now() }`
      }
      return `/images/avatar.png`
    }

    return {
      messages,
      dayjs,
      updateMessage,
      getAvatar,
    };
  },
});
</script>
  
<style lang="scss" >
  .avatar {
    border-radius: 50%;
    
  }
</style>